import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { ProfileFollowList } from '@core/Areas/FollowMe/Components/ProfileFollowList'
import { followMePrincipleProfileQuery } from '@core/Areas/FollowMe/helpers/queries'
import { FollowListPageLoader } from '@core/Areas/FollowMe/Components/ProfileFollowList/Components/FollowListPageLoader'

export const MyProfileFollowListPage = () => {
  const { data, isLoading } = useQuery(followMePrincipleProfileQuery)

  if (isLoading || !data) {
    return <FollowListPageLoader />
  }

  return <ProfileFollowList profile={data} />
}
